import { Helmet } from 'react-helmet-async';
import { filter, set } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Pagination,
  TextField,
  Box,
  Modal,
  Grid,
  FormLabel,
  Input,
  Select,
  FormControl,
} from '@mui/material';
import { Dropdown, Menu } from '@mui/base';
import { MenuButton } from '@mui/base/MenuButton';
import { menuItemClasses } from '@mui/base/MenuItem';
import { styled } from '@mui/system';

import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import '../css/style.css';
import { CSVLink } from 'react-csv';
import dayjs from 'dayjs';
import StaticEmployeemodel from '../components/models/Employee/StaticEmployeemodel';
import {
  GetSinglestaticemployee,
  GetstaticEmployee,
  SearchEmployee,
  Updatestaticemployee,
} from '../redux/actions/Employeeaction';
import Viewmodel from '../components/models/user/Viewmodel';
import { validateuser } from '../validation/user';
import {
  SearchUser,
  addUser,
  adddynamicUser,
  deleteUser,
  getSingleUser,
  getViewUser,
  updateUser,
} from '../redux/actions/userlistaction';
import StepperModal from '../components/models/stepperModal';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import Editusermodel from '../components/models/user/Editusermodel';
import Newdynamicuser from '../components/models/user/Newdynamicuser';
import Deleteusermodel from '../components/models/user/Deleteusermodel';
import Newuser from '../components/models/user/Newuser';
import CONSTANT from '../utils/constant.json';
import { swapKeysAndValues } from '../utils/utils';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'Name', label: 'Name', alignRight: false },
  { id: 'Employer', label: 'Company', alignRight: false },
  { id: 'Email', label: 'Email', alignRight: false },
  { id: 'PhoneNumber', label: 'Phone', alignRight: false },
  // { id: 'role', label: 'Role', alignRight: false },
  // { id: 'kycstatus', label: 'kycstatus', alignRight: false },
  // { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilizedThis?.map((el) => el[0]);
}

export default function Employeestatic() {
  const dispatch = useDispatch();

  // get user  data
  const getUsers = useSelector((state) => {
    return state?.Salary?.getstaticEmployee?.data;
  });

  const [open, setOpen] = useState(null);
  const [timeoutVal, setTimeoutVal] = useState(null);
  const [modelopen, setModelOpen] = useState(null);
  const [viewopen, setViewopen] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [dynamicmodel, setDynamicmodel] = useState(null);
  const [Deletemodel, setDeleteModel] = useState(null);
  const [Editmodel, setEditModel] = useState(false);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [excelFile, setExcelFile] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const [singleid, setSingleId] = useState('');
  const [state, setState] = useState([]);
  const [fielderror, setFieldError] = useState({});
  const [issubmit, setIssubmit] = useState(false);
  const [Filename, setFilename] = useState('');
  const [fail, setFail] = useState(false);
  const [failureData, setFailureData] = useState({});
  const [month, setMonth] = useState('');
  const [fromdate, setFromdate] = useState(dayjs().subtract(1, 'year').startOf('day'));
  const [todate, setTodate] = useState(dayjs().endOf('day'));
  const [personName, setPersonName] = useState([]);
  const [sort, setSort] = useState(false);

  const [errormessage, setErrormessage] = useState('');
  const [errordata, setErrordata] = useState('');
  const [error, setError] = useState('');

  // upalod file state state
  const [excelData, setExcelData] = useState(null);
  const [employeeData, setEmployeeData] = useState(getUsers);
  const fromdata = dayjs(fromdate).format();
  const todata = dayjs(todate).format();

  useEffect(() => {
    setEmployeeData(getUsers);
  }, [getUsers]);

  useEffect(() => {
    if (getUsers && getUsers.length > 0)
      setEmployeeData(
        getUsers.map((item) => {
          return {
            Name: item.Name,
            Employer: item.Employer,
            Email: item.EmployeeEmailId,
            PhoneNumber: item.PhoneNumber,
            UserId: item.UserId,
            Month: item.Month,
          };
        })
      );
  }, [getUsers]);
  const handleFilter = () => {
    dispatch(GetstaticEmployee(filterName, rowsPerPage, page, fromdata, todata, personName));
    setSort(false);
  };

  const handleselectChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  // Delete model
  const handeldeleteopen = () => setDeleteModel(true);
  const handeldeleteclose = () => setDeleteModel(false);

  // model open
  const handleOpen = () => setModelOpen(true);
  const handleClose = () => {
    setError(false);
    setErrormessage('');
    setErrordata('');
    setModelOpen(false);
    setFilename(false);
  };

  // view model
  // view model

  const handleViewOpen = (id) => {
    setSelectedUserId(id);
    setState(viewUser || {});
    setViewopen(true);
  };

  const handleViewClose = () => {
    setViewopen(false);
    setOpen(false);
    setState(false);
    setMonth('');
  };

  // failmodel

  const handelfailopen = () => setFail(true);
  const handelfailclose = () => setFail(false);
  const handelFailok = () => {
    setFailureData(state);
    const obj = {
      kycstatus:
        state?.Aadhar === 'verified' && state?.Profile === 'verified' && state?.Pan === 'verified'
          ? 'success'
          : 'inprogress',
      kycreason: {
        AadharReason: state?.AadharReason || '',
        PanReason: state?.PanReason || '',
        ProfileReason: state?.ProfileReason || '',
        Aadhar: state?.Aadhar || '',
        Pan: state?.Pan || '',
        Profile: state?.Profile || '',
      },
    };
    dispatch(updateUser(singleid, obj)).then((res) => {
      if (res.status === 200) {
        toast.success(res?.data?.message);
      } else if (res.status === 400) {
        toast.error('');
      }
    });
  };

  // dynamicuser
  // model open
  const handledynamicOpen = () => setDynamicmodel(true);
  const handledynamicClose = () => {
    setDynamicmodel(false);
    setFilename(false);
  };

  // Edit model
  const handleEditOpen = (id, month) => {
    setSingleId(id);
    setState(singleUser);
    setMonth(month);
    setEditModel(true);
    dispatch(GetSinglestaticemployee(id, month));
  };

  const handleEditClose = () => {
    setEditModel(false);
    setOpen(false);
    setState(false);
    setMonth('');
  };

  const handleOpenMenu = (event, id, month) => {
    setOpen(event.currentTarget);
    setSingleId(id);
    setMonth(month);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleChange = (e) => {
    const keyName = e.target.name;
    const keyValue = e.target.value;

    setState((prevState) => ({
      ...prevState,
      [keyName]: keyValue,
    }));

    if (issubmit) {
      setFieldError(validateuser({ ...state, [keyName]: keyValue }));
    }
  };

  // upload file

  const handleFile = (e) => {
    const fileTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
    ];
    const selectedFile = e.target.files[0];
    setFilename(selectedFile?.name);
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        const reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);
          handleFileSubmit(e.target.result);
        };
      } else {
        setTypeError('Please select only excel file types');
        setExcelFile(null);
      }
    } else {
      console.log('Please select your file');
    }
  };

  // submit event
  const handleFileSubmit = (e) => {
    if (e !== null) {
      const workbook = XLSX.read(e, { type: 'buffer' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);
      data.map((item) => {
        Object.entries(item).map((el) => {
          item[el[0]] = String(el[1]);
          return null;
        });
        return null;
      });
      setExcelData(data);
    }
  };

  // for table data

  const visibleRows = React.useMemo(() => {
    return applySortFilter(employeeData, getComparator(order, orderBy));
  }, [employeeData, order, orderBy]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = getUsers?.users?.map((n) => n.Name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (timeoutVal) {
      clearTimeout(timeoutVal);
      setTimeoutVal(null);
    }
    const timeout = setTimeout(() => {
      dispatch(GetstaticEmployee(filterName, rowsPerPage, page, fromdata, todata, personName));
    }, 2000);
    setTimeoutVal(timeout); 
  }, [filterName, rowsPerPage, page]);

  // delete user
  const handeldelete = () => {
    dispatch(deleteUser(singleid));
    setDeleteModel(false);
    setOpen(null);
  };

  // edit user

  const singleUser = useSelector((state) => state?.Salary?.Getstaticsingle);
  const viewUser = useSelector((state) => state?.User?.getViewuser?.data);

  // upload excel

  const UserData = [
    'Name',
    'Employer Name',
    'Employee ID',
    'Employment type',
    'Employee Risk Category',
    'Employer Risk Category',
    'Employee email id',
    'Designation',
    'City',
    'Year of joining',
    'Employment Status (permanent/probation/trainee/contract/notice period)',
    'Phone number',
    'Bank',
    'Bank Acc No',
    'IFSC Number',
    'PAN Number',
    'Adhar Card',
    'Employee stock / ESOPs',
    'Month',
    'Paydays',
    'Net Salary',
    'Gross Salary',
    'Fixed Salary',
    'Fixed Variable Salary',
    'Bonus',
    'Deductions',
    'LOP Days',
    'Overtime',
    'Allowance',
    'Arrears',
    'Reimbursements',
    'Relocation Expenses',
    'loan EMI from company',
    'company credit card usage',
    'Advance in lieu of company expenses',
    'Year end settlements',
    // 'Loss of Pay days',
    'Resignation Date',
    'Notice period',
    'Terminated',
    'On Probation',
    'probation period',
    'On sabbatical',
    'Sabbatical period',
    'Employee outstanding',
    'Last date of employment',
  ];

  const UserdynamicData = [
    'UserId',
    'EmployerId',
    'LOPDays',
    'EmployeeOutStanding',
    'LastDateofEmployement',
    'MinAmtValue',
    'Notice',
    'Probation',
    'TemporaryDeactivation',
    'Terminated',
    'WithdrawalFactor',
    'YearEndSettlement',
  ];

  const handelok = () => {
    let error = false;
    const otherFields = Object?.keys(excelData?.[0])?.filter((fieldName) => !UserData.includes(fieldName));
    if (otherFields?.length > 0) {
      otherFields?.map((e) => {
        error = true;
        return toast.error(`${e} is not allowed`);
      });
    }
    const keys = Object.keys(CONSTANT.USER_DATA);
    keys.map((item) => {
      if (!Object.keys(excelData[0]).find((el) => el === item)) {
        error = true;
        toast.error(`${item} is required`);
      }
      return null;
    });
    const excelDataList = JSON.parse(JSON.stringify(excelData));
    excelDataList.map((item) => {
      Object.entries(item).map((el) => {
        delete item[el[0]];
        if (CONSTANT.USER_NUMBER.includes(el[0])) {
          item[CONSTANT.USER_DATA[el[0]]] = Number(el[1]);
        } else {
          item[CONSTANT.USER_DATA[el[0]]] = String(el[1]);
        }
        return null;
      });
      return null;
    });
    if (!error) {
      dispatch(
        addUser({
          data: excelDataList,
        })
      ).then((res) => {
        if (res?.data?.status === 200 || res?.data?.status === 201) {
          setModelOpen(false);
          // dispatch(GetstaticEmployee(filterName, rowsPerPage, page, fromdata, dayjs()));
          toast.success(res?.data?.message);
        } else if (res?.data?.status === 400) {
          toast.error(res?.data?.message);
          setError(true);
          setErrormessage(res?.data?.message);
          setErrordata(res?.data?.data);
        } else {
          toast.error(res?.response?.data?.message);
        }
      });
    }

    // if (typeError) {
    //   console.log('typeError', typeError);
    // }
    // else if (obj.data?.length > 0) {
    //   dispatch(addUser(obj)).then((res) => {
    //     if (res.status === 200) {
    //       setModelOpen(false);
    //     }
    //   });
    //   setModelOpen(false);
    //   setOpen(false);
    // }
  };

  // dynamic user
  const handeldynamicok = () => {
    let error = false;
    const otherFields = Object?.keys(excelData?.[0])?.filter((fieldName) => !UserdynamicData.includes(fieldName));
    if (otherFields?.length > 0) {
      otherFields?.map((e) => {
        error = true;
        return toast.error(`${e} is not allowed`);
      });
    }
    const obj = {
      data: excelData,
    };

    if (!error) {
      dispatch(adddynamicUser(obj)).then((res) => {
        if (res.status === 200) {
          setDynamicmodel(false);
        } else if (res?.data?.status === 400) {
          toast.error('sf');
        }
      });
    }
  };

  // edit user
  const handelEditstatic = () => {
    const obj = {
      Bank: state?.Bank,
      GrossSalary: state?.GrossSalary,
      Reimbursements: state?.Reimbursements,
      SabbaticalPeriod: state?.SabbaticalPeriod,
      CreatedAt: state?.CreatedAt,
      NetSalary: state?.NetSalary,
      EmploymentType: state?.EmploymentType,
      YearOfJoining: state?.YearOfJoining,
      EmployeeEmailId: state?.EmployeeEmailId,
      NoticePeriod: state?.NoticePeriod,
      Terminated: state?.Terminated,
      Name: state?.Name,
      Paydays: state?.Paydays,
      AdvanceLieuCompanyExpenses: state?.AdvanceLieuCompanyExpenses,
      YearEndSettlements: state?.YearEndSettlements,
      Month: state?.Month,
      FixedSalary: state?.FixedSalary,
      LOPDays: state?.LOPDays,
      Allowance: state?.Allowance,
      Designation: state?.Designation,
      OnSabbatical: state?.OnSabbatical,
      RelocationExpenses: state?.RelocationExpenses,
      ResignationDate: state?.ResignationDate,
      Employer: state?.Employer,
      LoanEMIFromCompany: state?.LoanEMIFromCompany,
      OnProbation: state?.OnProbation,
      EmploymentStatus: state?.EmploymentStatus,
      Bonus: state?.Bonus,
      EmployeeOutstanding: state?.EmployeeOutstanding,
      City: state?.City,
      EmployeeRiskCategory: state?.EmployeeRiskCategory,
      AdharCard: state?.AdharCard,
      Arrears: state?.Arrears,
      Overtime: state?.Overtime,
      EmployerRiskCategory: state?.EmployerRiskCategory,
      ESOPs: state?.ESOPs,
      PhoneNumber: state?.PhoneNumber,
      PanNumber: state?.PanNumber,
      Deductions: state?.Deductions,
      CompanyCreditCardUsage: state?.CompanyCreditCardUsage,
      LossOfPayDays: state?.LossOfPayDays,
      EmployeeID: state?.EmployeeID,
      BankAccountNumber: state?.BankAccountNumber,
      IFSCNumber: state?.IFSCNumber,
      LastDateOfEmployment: state?.LastDateOfEmployment,
      FixedVariableSalary: state?.FixedVariableSalary,
      ProbationPeriod: state?.ProbationPeriod,
    };
    const userObj = swapKeysAndValues(CONSTANT.USER_DATA);
    Object.entries(obj).map((el) => {
      if (CONSTANT.USER_NUMBER_KEY.includes(el[0])) {
        obj[el[0]] = Number(el[1]);
      } else {
        obj[el[0]] = String(el[1]);
      }
      return null;
    });
    // setIssubmit(true);
    dispatch(Updatestaticemployee(singleid, month, obj)).then((res) => {
      if (res.status === 200) {
        toast.success('success');
        dispatch(GetstaticEmployee(filterName, rowsPerPage, page, fromdata, todata, personName));
        setSingleId(false);
        setState(false);
        setMonth('');
        handleEditClose();
      }
    });
    // const error = validateuser(state);
    // if (Object.keys(error).length === 0) {
    //   setEditModel(false);
    //   setOpen(false);
    // } else {
    //   console.log('Error:', error);
    // }
    // setFieldError(validateuser(state));
  };

  // for table

  const filteredUsers = applySortFilter(getUsers?.users, getComparator(order, orderBy), filterName);
  const isNotFound = !filteredUsers?.length && !!filterName;

  useEffect(() => {
    setState(failureData);
  }, [failureData]);

  return (
    <>
      <Helmet>
        <title> Employee | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Employee static
          </Typography>
          <Box sx={{ display: 'flex', gap: '10px' }}>
            <Button onClick={handleOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
              Upload static Employee
            </Button>
            <Button variant="contained">
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={getUsers !== undefined ? getUsers : []}
                filename="static Employees.csv"
                target=""
              >
                Download CSV
              </CSVLink>
            </Button>
          </Box>
        </Stack>

        {/* NEW USER MODEL */}
        <Newuser
          name="Employee"
          handelok={handelok}
          Filename={Filename}
          modelopen={modelopen}
          handleClose={handleClose}
          handleFileSubmit={handleFileSubmit}
          handleFile={handleFile}
          typeError={typeError}
          errormessage={errormessage}
          errordata={errordata}
          error={error}
        />

        {/* view model */}
        <Viewmodel
          viewopen={viewopen}
          handleViewClose={handleViewClose}
          state={state}
          name="Static user"
          userId={selectedUserId}
        />

        {/* edit model */}

        <StaticEmployeemodel
          name="static Employee"
          fielderror={fielderror}
          handleChange={handleChange}
          Editmodel={Editmodel}
          state={singleUser}
          setState={setState}
          handleEditClose={handleEditClose}
          handelEditstatic={handelEditstatic}
        />

        {/*  */}
        <Card>
          <UserListToolbar
            name="EmployeeStatic"
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            typeError={typeError}
            setFromdate={setFromdate}
            setTodate={setTodate}
            handleselectChange={handleselectChange}
            personName={personName}
            handleFilter={handleFilter}
            sort={sort}
            setSort={setSort}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, minHeight: 300 }}>
              <Table sx={{ px: '10px' }}>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={getUsers?.count}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {visibleRows &&
                    visibleRows?.map((row, index) => {
                      const { UserId, Name, Employer, Email, PhoneNumber, Month } = row;
                      return (
                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                          <TableCell
                            sx={{ cursor: 'pointer', paddingLeft: '10px' }}
                            onClick={() => handleViewOpen(UserId)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar alt={Name} />
                              <Typography variant="subtitle2" noWrap>
                                {Name}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell sx={{ cursor: 'pointer' }} onClick={() => handleViewOpen(UserId)} align="left">
                            {Employer}
                          </TableCell>
                          <TableCell sx={{ cursor: 'pointer' }} onClick={() => handleViewOpen(UserId)} align="left">
                            {Email}
                          </TableCell>
                          <TableCell sx={{ cursor: 'pointer' }} onClick={() => handleViewOpen(UserId)} align="left">
                            {PhoneNumber}
                          </TableCell>

                          {/* <TableCell align="left">{Role}</TableCell> */}

                          {/* <TableCell align="left">
                          {kycstatus === 'inprogress' && (
                            <>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Iconify
                                  icon={'heroicons:exclaimation-circle-solid'}
                                  sx={{ m: 'auto', color: 'orange', textAlign: 'center' }}
                                />
                                <Button onClick={(e) => handleCheck(e, index, id)}>Check</Button>
                              </div>
                            </>
                          )}
                          {kycstatus === 'success' && <Iconify icon={'ooui:success'} sx={{ mr: 2, color: 'green' }} />}
                          {kycstatus === 'failure' && (
                            <Iconify icon={'icomoon-free:cross'} sx={{ mr: 2, color: 'red' }} />
                          )}
                        </TableCell> */}

                          <TableCell sx={{ cursor: 'pointer' }} align="right">
                            <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, UserId, Month)}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 125]}
            component="div"
            count={getUsers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => handleEditOpen(singleid, month)}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem onClick={handeldeleteopen} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>

        {/* edit model */}

        {/* delete model */}

        <Deleteusermodel Deletemodel={Deletemodel} handeldeleteclose={handeldeleteclose} handeldelete={handeldelete} />
      </Popover>
    </>
  );
}
